var isSSR=function(){return"undefined"==typeof window};export{isSSR};
//# sourceMappingURL=ssrUtils.js.map
